module.exports = __webpack_public_path__ + "img/Mstorybg802.959f39a3.png";